import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
export const CheckoutConfirmationEVoucherDeliveryInfo = ({ contactPerson, digitalDeliveryInfo }) => (_jsxs(TextAlpha, { children: [digitalDeliveryInfo, ' ', _jsx(TextAlpha, { as: "span", strong: true, color: "success", children: contactPerson })] }));
